export enum TrackedUserTypes {
  CockpitClientUser = 'cockpit-client-user',
  CockpitFunderUser = 'cockpit-funder-user',
}
